import { useEffect } from 'react';

/** 서비스 사이트 공통 (CR-031) */
export const CONTACT_EMAIL = 'prism@3707.kr';
const BASE_TITLE = 'PRISM · 개인정보 및 정보보호 관리시스템';
export function useTitle(title?: string) {
  useEffect(() => { document.title = title ? `PRISM · ${title}` : BASE_TITLE; return () => { document.title = BASE_TITLE; }; }, [title]);
}
